import GridAlternateIcon from '../../atoms/icons/grid-alternate-icon'
import GridDefaultIcon from '../../atoms/icons/grid-default-icon'
import GridAlternateIconMob from '@/components/ui/atoms/icons/grid-alternate-icon-mob'
import GridDefaultIconMob from '@/components/ui/atoms/icons/grid-default-icon-mob'
import { cx } from '@emotion/css'
import { Root, Icon, Label } from './view-mode.styled'
import { string, func, node, shape } from 'prop-types'
import { useState } from 'react'
import { useThemeProps, useTheme } from '@mui/system'
import useMediaQuery from '@mui/material/useMediaQuery'

const ViewMode = ({ ...inProps }) => {
	const props = useThemeProps({
		name: 'BHViewMode',
		props: inProps,
	})

	const theme = useTheme()
	const smUp = useMediaQuery(theme.breakpoints.up('sm'))
	const { label, variant, onClick, className, defaultIconProps, alternateIconProps, labelProps } = props
	const [mode, setMode] = useState(variant ?? 'default')

	const onClickHandler = (mode) => {
		setMode(mode)
		if (onClick) {
			onClick(mode)
		}
	}

	return (
		<Root className={cx('ViewMode-root', className)}>
			{label ? (
				<Label component="span" {...labelProps}>
					{label}
				</Label>
			) : null}

			<Icon
				color={mode === 'default' ? 'primary' : 'grey'}
				onClick={() => onClickHandler('default')}
				variant="textNoLink"
				StartIcon={() => (smUp ? <GridAlternateIcon fontSize="button" /> : <GridAlternateIconMob fontSize="button" />)}
				{...defaultIconProps}
			/>
			<Icon
				color={mode === 'alternate' ? 'primary' : 'grey'}
				onClick={() => onClickHandler('alternate')}
				variant="textNoLink"
				StartIcon={() => (smUp ? <GridDefaultIcon fontSize="button" /> : <GridDefaultIconMob fontSize="button" />)}
				{...alternateIconProps}
			/>
		</Root>
	)
}

ViewMode.propTypes = {
	label: node,
	variant: string,
	onClick: func,
	className: string,
	defaultIconProps: shape({ ...Icon.propTypes }),
	alternateIconProps: shape({ ...Icon.propTypes }),
	labelProps: shape({ ...Label.propTypes }),
}

export default ViewMode
